import enLang from "./entries/en-US";
import saLang from "./entries/ar_SA";

const AppLocale = {
  en: enLang,
  sa: saLang,
};

export default AppLocale;
